import debounce from 'lodash.debounce';
import moment from 'moment';
import {useState, useCallback} from 'react';

const useFilters = (action, searchKey = 'q') => {
  const [filters, setFilters] = useState({});
  const [customerToShow, setCustomerToShow] = useState(null);
  const searchValue = filters[searchKey] || '';
  const building = filters?.buildingId || '';
  const elevator = filters?.elevatorId || '';
  const entrance = filters?.entranceId || '';
  const garage = filters?.garageId || '';
  const customer = filters?.customerId || '';
  const dateRanges = filters?.startTime
    ? [filters.startTime, filters.endTime]
    : null;

  const debouncedSearch = useCallback(
    debounce(value => {
      action(value);
    }, 500),
    [],
  );

  const onSearchChange = e => {
    const filtersClone = {...filters};
    const value = e.currentTarget.value;
    if (value === '') {
      delete filtersClone[searchKey];
    } else {
      filtersClone[searchKey] = value;
    }
    setFilters({...filtersClone});
    debouncedSearch(filtersClone);
  };

  const onChangeDates = values => {
    const filtersClone = {...filters};
    if (values) {
      filtersClone.startTime = moment(values[0]).startOf('day').valueOf();
      filtersClone.endTime = moment(values[1]).endOf('day').valueOf();
      setFilters({...filtersClone});
      action(filtersClone);
    } else {
      delete filtersClone.startTime;
      delete filtersClone.endTime;
      setFilters({...filtersClone});
      action(filtersClone);
    }
  };

  const onChangeSelect = (value, field) => {
    const filtersClone = {...filters};
    filtersClone[field] = value;
    setFilters({...filtersClone});
    action(filtersClone);
  };

  const onCustomerChange = (value, field) => {
    const filtersClone = {...filters};
    setCustomerToShow(value);
    filtersClone[field] = value.id;
    setFilters({...filtersClone});
    action(filtersClone);
  };

  const clearSelect = field => {
    const filtersClone = {...filters};
    delete filtersClone[field];
    setFilters({...filtersClone});
    action(filtersClone);
  };

  // An entrance/garage belongs to one project, so changing or clearing the project drops them too.
  const onChangeBuilding = value => {
    const filtersClone = {...filters, buildingId: value};
    delete filtersClone.entranceId;
    delete filtersClone.garageId;
    setFilters({...filtersClone});
    action(filtersClone);
  };
  const onChangeElevator = value => onChangeSelect(value, 'elevatorId');
  const onChangeEntrance = value => onChangeSelect(value, 'entranceId');
  const onChangeGarage = value => onChangeSelect(value, 'garageId');
  const onChangeCustomer = value => onCustomerChange(value, 'customerId');
  const clearBuilding = () => {
    const filtersClone = {...filters};
    delete filtersClone.buildingId;
    delete filtersClone.entranceId;
    delete filtersClone.garageId;
    setFilters({...filtersClone});
    action(filtersClone);
  };
  const clearElevator = () => clearSelect('elevatorId');
  const clearEntrance = () => clearSelect('entranceId');
  const clearGarage = () => clearSelect('garageId');
  const clearCustomer = () => clearSelect('customerId');

  return {
    filters,
    searchValue,
    building,
    elevator,
    entrance,
    garage,
    customer,
    customerToShow,
    dateRanges,
    onSearchChange,
    onChangeBuilding,
    onChangeElevator,
    onChangeEntrance,
    onChangeGarage,
    onChangeCustomer,
    onChangeDates,
    clearBuilding,
    clearElevator,
    clearEntrance,
    clearGarage,
    clearCustomer,
  };
};

export default useFilters;
